import type { ProductionRunDto } from '../../types/foam';

/** Normalise une chaîne optionnelle : trim, et undefined si vide. */
function nonEmpty(value?: string): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

/** Libellé court d'un run, ex. "High Resilience HR (35) - Run number 1". */
export function formatRunLabel(
  run: Pick<ProductionRunDto, 'foamTypeName' | 'gradeRef' | 'runNo'>
): string {
  const foam = nonEmpty(run.foamTypeName);
  const grade = nonEmpty(run.gradeRef);
  const base = foam ?? grade ?? 'Run';
  const name = foam && grade ? `${base} (${grade})` : base;
  return run.runNo != null ? `${name} - Run number ${run.runNo}` : name;
}

/** Titre compact pour les cartes de la page d'accueil, ex. "HR 35 - Run 3". */
export function formatRunTitle(run: Pick<ProductionRunDto, 'gradeRef' | 'runNo'>): string {
  const grade = nonEmpty(run.gradeRef) ?? 'Run';
  return run.runNo != null ? `${grade} - Run ${run.runNo}` : grade;
}

/** Date d'un run formatée localement (jj/mm/aaaa). */
export function formatRunDate(run: Pick<ProductionRunDto, 'runDate' | 'createdAtUtc'>): string {
  const iso = run.runDate ?? run.createdAtUtc;
  if (!iso) return '';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
}
